import { styled } from '@mui/material';

const Spacer = styled('div')({
  height: '10px', // adjust this value for desired spacing
});

export default Spacer